import SLABanner from './SLABanner';

export default SLABanner;
